import * as actionType from './actionType';
import * as action from './action';
import reducer from './reducer';

export { actionType, action, reducer };


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/set_tag/index.js